import React, { FC, useState, ReactNode } from 'react'
import { PhotographIcon } from '@heroicons/react/solid'
import { Link } from 'react-router-dom'
import { StyledCartItem } from '.'
import { CartItemType, CourseType, CartItemsType } from '../../types'
import { Button } from '../System'
import usePricing from '../../redux/pricing/usePricing'
import ROUTES from '../utils/routes'
import { FlexGroup } from '../Grid'

type Props = {
  item: CartItemType;
  isReceipt?: boolean;
  paymentPlanSelect?: ReactNode;
  removeFromCart?(id: string, type: CartItemsType): void;
}

const CartItem: FC<Props> = ({
  item, isReceipt, paymentPlanSelect, removeFromCart
}) => {
  const { actions: { getPriceData } } = usePricing()
  const cartPrice = getPriceData(item.type)
  const [imgBroken, setImgBroken] = useState(false)

  const getItemImage = () => {
    if (item.type === 'course' && (item.itemData as CourseType).coverImage?.fileHttpLink) {
      return (item.itemData as CourseType).coverImage.fileHttpLink
    }

    if (item.type === 'subscription') {
      return 'https://hello.socialcurator.com/getImageFromPath?imagePath=images/9822370-SC-11-2021-13.JPG'
    }

    return ''
  }

  const getItemDescription = () => {
    if (item.type === 'course') {
      return 'Course'
    }

    if (item.type === 'subscription') {
      return (item.itemData as any).description
    }

    return `Issue`
  }

  const getItemUrl = () => {
    if (!item.itemData.slug) {
      return ''
    }

    if (item.type === 'course') {
      return ROUTES.courses.previewBySlug(item.itemData.slug)
    }

    return ROUTES.issues.viewBySlug(item.itemData.slug)
  }

  return (
    <StyledCartItem>
      <div className="cart-item">
        <div className="item-details">
          <div className="item-preview">
            {!imgBroken && (
              <img
                src={getItemImage() || ''}
                alt={item.itemData.title}
                onError={() => setImgBroken(true)}
              />
            )}
            {imgBroken && <PhotographIcon />}
          </div>
          <div className="item-info">
            <span className="item-title">{item.itemData.title}</span>
            <span className="item-description">{getItemDescription()}</span>
          </div>
        </div>
        {!isReceipt && (
          <div className="item-actions">
            {cartPrice && (
              <FlexGroup>
                <b>
                  $
                  {cartPrice &&
                    (cartPrice.sale
                      ? cartPrice.sale.valueAfterDiscount.toFixed(2)
                      : cartPrice.price.toFixed(2))}
                </b>
                {cartPrice && cartPrice.sale && (
                  <span className="slashed-price">${cartPrice.price.toFixed(2)}</span>
                )}
              </FlexGroup>
            )}

            {removeFromCart && item.type !== 'subscription' && (
              <Button
                onClick={() => removeFromCart(item.itemData._id, item.type)}
                theme="ghost"
                type="small"
                className="remove-item-btn"
              >
                Remove
              </Button>
            )}
          </div>
        )}
        {isReceipt && (
          <Link to={getItemUrl()} className="view-btn">
            <Button theme="outline">View {item.type}</Button>
          </Link>
        )}
      </div>
      {paymentPlanSelect}
    </StyledCartItem>
  )
}

export default CartItem
